// extracted by mini-css-extract-plugin
export default {"pageFooter":"Footer_pageFooter__YFdbH","contactUs":"Footer_contactUs__1jgx0","item":"Footer_item__jcLP0","shortNav":"Footer_shortNav__kys-t","navLink":"Footer_navLink__Humna"};